"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextareaCounter = void 0;
var temas_frontend_1 = require("@aura/temas-frontend");
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importStar(require("react"));
var paragraphy_styles_1 = require("../../token/paragraphy/paragraphy.styles");
var textarea_styles_1 = require("./textarea.styles");
var TextareaCounter = function (_a) {
    var _b;
    var placeholder = _a.placeholder, limitCounter = _a.limitCounter, name = _a.name, value = _a.value, hasError = _a.hasError, isTouched = _a.isTouched, textareaValid = _a.textareaValid, onChange = _a.onChange, disabled = _a.disabled, className = _a.className, label = _a.label, errorMsg = _a.errorMsg, textareaProps = _a.textareaProps, required = _a.required, width = _a.width, margin = _a.margin, hideErrorIcon = _a.hideErrorIcon, manterEstilo = _a.manterEstilo, ariaLabelTextarea = _a.ariaLabelTextarea;
    var theme = (0, temas_frontend_1.useTheme)().theme;
    var error = isTouched && hasError;
    var errorClassName = manterEstilo ? "error ".concat(className) : 'error';
    var _c = (0, react_1.useState)(limitCounter), contador = _c[0], setContador = _c[1];
    var valueLength = (_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0;
    (0, react_1.useEffect)(function () {
        if (textareaProps.defaultValue) {
            setContador(limitCounter - textareaProps.defaultValue.length);
        }
        else {
            setContador(limitCounter - valueLength);
        }
    }, [textareaProps.defaultValue, setContador, limitCounter, valueLength]);
    var definirContador = (0, react_1.useCallback)(function (texto) {
        var tamanhoTexto = texto.length;
        var resultadoCalculoContador = limitCounter - tamanhoTexto;
        setContador(resultadoCalculoContador);
    }, [limitCounter]);
    var onInput = (0, react_1.useCallback)(function (e) {
        var texto = e.target.value;
        definirContador(texto);
    }, [definirContador]);
    var validateTextArea = function () {
        if (hasError) {
            return errorClassName;
        }
        else if (isTouched) {
            return 'touched';
        }
        else if (disabled) {
            return 'disabled';
        }
        else {
            return className;
        }
    };
    var getContadorAcessibilidadeLabel = (0, react_1.useCallback)(function () {
        return contador > 0
            ? "utilizados ".concat(limitCounter - contador, " de ").concat(limitCounter, " dispon\u00EDveis")
            : 'limite máximo de caracteres atingido';
    }, [contador, limitCounter]);
    return (react_1.default.createElement(textarea_styles_1.TextareaCountContainerStyled, null,
        react_1.default.createElement(textarea_styles_1.TextareaCounterSectionStyled, { width: width, margin: margin, className: textareaValid ? 'valid' : validateTextArea() },
            react_1.default.createElement(textarea_styles_1.TextareaCounterTextareaStyled, __assign({ "data-testid": "text-area", placeholder: placeholder, "aria-label": ariaLabelTextarea ? ariaLabelTextarea : label, name: name, type: "text", maxLength: limitCounter, value: value, onInput: onInput, onChange: onChange, on: "true", disabled: disabled, error: error, required: required }, textareaProps)),
            react_1.default.createElement(textarea_styles_1.TextareaCounterLabelStyled, { "data-testid": "text-area-label", type: "text" }, label),
            error && !hideErrorIcon && (react_1.default.createElement("div", { className: "icoError" },
                react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.AlertTriangle, size: 'md', dataTestId: "text-area-icone-erro" })))),
        error && errorMsg && (react_1.default.createElement(paragraphy_styles_1.PStyled, { "data-testid": "text-area-mensagem-erro", small: true, bold: true, color: theme.error, style: { marginTop: '8px', marginLeft: '16px', marginBottom: "".concat(error ? '16px' : '0') } }, errorMsg)),
        react_1.default.createElement(paragraphy_styles_1.PStyled, { "aria-hidden": true, "data-testid": "text-area-contador", className: "contador ".concat(contador === 0 && 'contador-zerado') },
            contador,
            " / ",
            limitCounter),
        react_1.default.createElement("p", { "data-testid": "acessibilidade-contador", className: 'somenteLeitorDeTela' }, getContadorAcessibilidadeLabel())));
};
exports.TextareaCounter = TextareaCounter;
